import { onMounted, ref } from '@vue/runtime-core'

export default function useLifeCycleState() {
	const isMounted = ref(false)
	onMounted(() => (isMounted.value = true))

	return {
		isMounted
	}
}
